import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=352c1f0a&scoped=true&"
import script from "./ErrorContent.vue?vue&type=script&lang=js&"
export * from "./ErrorContent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContent.vue?vue&type=style&index=0&id=352c1f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c1f0a",
  null
  
)

export default component.exports